import Container from "@components/shared/Container";
import Card from "@components/shared/Card";
import DashboardCard from "@components/shared/DashboardCard";
import ParticipantDashboardCard from "@components/shared/ParticipantDashboardCard";

import ParticipantsTable from "@components/stat/participant/table/ParticipantsTable";
import TransactionsTable from "@components/stat/transaction/table/TransactionsTable";
import AttendancesTable from "@components/stat/attendance/table/AttendancesTable";
import { useAppStore } from "@store/appStateStore";
import CoachDashboardCard from "@components/shared/CoachDashboardCard";
import Calendar from "@components/shared/Calendar";
import OverwiewDashboard from "@components/shared/OverwiewDashboard/OverwiewDashboard";

const HomeTab: React.FC = () => {
  const { user, attendances, participant, directions } = useAppStore();

  const customAttendances = participant
    ? attendances.filter((a) => a.participant_id === participant)
    : (attendances ?? []);

  const getTooltipContent = (date: any) => {
    const attendancesAtDate = customAttendances.filter((a) => a.date === date);
    var dirs: Record<
      number,
      { dirName: string; totalAmount: number; count: number }
    > = {};

    attendancesAtDate.forEach((a) => {
      if (!dirs?.[a.direction_id]) {
        const dirName =
          directions.find((d) => d.id === a.direction_id)?.name ?? "Не указано";
        dirs[a.direction_id] = { totalAmount: 0, count: 0, dirName: dirName };
      }
      dirs[a.direction_id].count += 1;
      dirs[a.direction_id].totalAmount += a.amount;
    });

    return (
      Object.entries(dirs).length &&
      Object.entries(dirs).map(([_, data]) => (
        <p>{`${data.dirName}: ${data.count} (${data.totalAmount} р.)`}</p>
      ))
    );
  };

  const renderContent = () => {
    switch (user?.code) {
      case "admin":
        return (
          <Container>
            <OverwiewDashboard />

            <DashboardCard />
            <Card>
              <Calendar
                selectedDates={customAttendances.map((a) => {
                  return { date: a.date, direction: a.direction_id };
                })}
                onDateRemove={() => {}}
                onDateSelect={() => {}}
                dateSectionSow={false}
                getTooltipContent={getTooltipContent}
              />
            </Card>
            <Card>
              <ParticipantsTable />
            </Card>
            <Card>
              <AttendancesTable hasAmount hasIsPaid />
            </Card>
            <Card>
              <TransactionsTable />
            </Card>
          </Container>
        );

      case "coach":
        return (
          <Container>
            <CoachDashboardCard />
          </Container>
        );

      default:
        return (
          <Container>
            <ParticipantDashboardCard />
          </Container>
        );
    }
  };

  return renderContent();
};

export default HomeTab;
